<template>
  <div class="activation-summary">
    <slot name="txtHeader"></slot>
    <div class="personal-data-content">
      <div class="before-personal-data"><slot name="txtBeforePersonalDataContent"></slot></div>
      <a @click.prevent="goToPersonalDataStep()" class="linkChange">
        <slot name="txtChange">ändern</slot>
      </a>
      <ShowSummaryPersonalData :customer="getCustomer">
        <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowSummaryPersonalData>
      <ShowIdentData>
        <template v-for="slot in possibleChildSlotsFor('IdentSummary')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowIdentData>
    </div>
    <div class="payment-content">
      <div class="payment-info">
        <a @click.prevent="goToPaymentStep()" class="linkChange">
          <slot name="txtChange">ändern</slot>
        </a>
        <ShowPaymentData :payment="_payment" v-if="hasTopUp">
          <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ShowPaymentData>
        <div class="payment-without-topup"  v-if="withoutTopUp">
          <slot name="txtPaymentWithoutTopup"></slot>
        </div>
      </div>
      <div class="topup-summary" v-if="savedTariff.tariffExtra.market === 'PUA'">
        <a @click.prevent="goToPaymentStep()" class="linkChange">
          <slot name="txtChange">ändern</slot>
        </a>
      <ShowTopUpData>
        <template v-for="slot in possibleChildSlotsFor('TopUp')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowTopUpData>
      </div>
    </div>
    <div class="consent-content">
      <ShowConsentData
        :consentAGB.sync="consent.agb"
        :consentInformationArticle.sync="consent.informationArticle"
        :selectedInfoExchangeConsent.sync="consent.exchange"
        :selectedContactConsent.sync="consent.contact"
        :contractTermsVersion.sync="consent.contractTermsVersion"
      >
        <template v-for="slot in possibleChildSlotsFor('Consent')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowConsentData>
    </div>
    <ShowTariffInfoBox :tariff="selectedTariff">
      <template v-for="slot in possibleChildSlotsFor('TariffInfoBox')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowTariffInfoBox>
    <Stepper
      @prev="prev()"
      @next="next()"
      :loading-next="loading"
      :disabledNext="disabledNext || loading"
      :show-prev="true"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { stepName as nextStep } from '@/components/process/LIDL/Activation/Success/ShowSuccessIdentLinks.vue'
import { stepName as previousStep } from '@/components/process/LIDL/Activation/TopUp/EnterTopUpAndPayment.vue'
import { stepName as personalDataStep } from '@/components/process/LIDL/Activation/PersonalData/EnterPersonalData.vue'
import processSteps from '@/mixins/processSteps'
import ShowPaymentData from '@/components/process/LIDL/Activation/Payment/ShowPaymentData.vue'
import ShowConsentData from '@/components/process/LIDL/Activation/Summary/ShowConsentData.vue'
import ShowTopUpData from '@/components/process/LIDL/Activation/TopUp/ShowTopUpData.vue'
import ShowIdentData from '@/components/process/LIDL/Activation/PersonalData/ShowIdentData.vue'
import Stepper from '@/components/generic/Stepper.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ShowSummaryPersonalData from '@/components/process/LIDL/Activation/PersonalData/ShowSummaryPersonalData.vue'
import slotProxy from '@/mixins/slotProxy'
import ShowTariffInfoBox from '@/components/process/LIDL/Activation/Tariff/ShowTariffInfoBox.vue'
export const stepName = 'summary'

export default {
  name: 'ActivationSummary',
  mixins: [
    processSteps(stepName, previousStep, nextStep),
    slotProxy()
  ],
  data () {
    return {
      loading: false,
      consent: {
        agb: false,
        informationArticle: false,
        exchange: false,
        contact: false,
        contractTermsVersion: null
      }
    }
  },
  computed: {
    _payment: function () {
      return {
        ...this.payment,
        type: this.payment.paymentType
      }
    },
    disabledNext: function () {
      return !this.consent.agb || !this.consent.informationArticle
    },
    selectedTariff: function () {
      return this.savedTariff || {}
    },
    ...mapGetters('activation/payment', [
      'payment'
    ]),
    ...mapGetters('activation/topUp', [
      'hasTopUp', 'withoutTopUp'
    ]),
    ...mapGetters('activation/tariff', [
      'savedTariff'
    ]),
    ...mapGetters('activation/personalData', [
      'personal',
      'address',
      'additional'
    ]),
    getCustomer () {
      return {
        salutation: this.personal.gender,
        firstName: this.personal.firstName,
        lastName: this.personal.lastName,
        birthDate: this.personal.birthDate,
        email: this.additional.email,
        address: this.address
      }
    }
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    ...mapActions('activation/submit', [
      'activationConfirm'
    ]),
    goToPersonalDataStep: function () {
      this.goToStep(personalDataStep)
    },
    goToPaymentStep: function () {
      this.goToStep(previousStep)
    },
    prev () {
      this.goToStep(this.previousStep)
    },
    async next () {
      this.loading = true
      await this.activationConfirm({ nextStep: this.nextStep, consents: this.consent })
      this.loading = false
    }
  },
  components: {
    ShowSummaryPersonalData,
    ShowIdentData,
    ShowPaymentData,
    ShowTopUpData,
    ShowConsentData,
    ShowTariffInfoBox,
    Stepper
  }
}
</script>
